module.exports = __webpack_public_path__ + "static/media/26UNRWA6.51f76dff.jpg";